import { useFormContext } from "react-hook-form";
import { Badge } from "@/components/shadcn/badge";
import { Info } from "lucide-react";
import { NoxusTooltip } from "@/components/UI/NoxusTooltip";

export const FieldBadgeField = ({
  sourceField,
  label,
  tooltip,
}: {
  sourceField: string;
  label?: string;
  tooltip?: string | null;
}) => {
  const form = useFormContext();
  const value = form.watch(sourceField);

  return (
    <div className="flex items-center bg-muted-foreground/5 justify-start gap-2 border -mt-2 rounded-md p-2">
      <span className="text-xs text-muted-foreground font-medium">{label}</span>
      {value && (
        <Badge variant="outline" className="font-mono text-xs">
          {value}
        </Badge>
      )}
      {tooltip && (
        <NoxusTooltip content={tooltip} classNameTrigger="ml-auto" align="end">
          <Info
            size={16}
            strokeWidth={1.25}
            className={"text-muted-foreground"}
          />
        </NoxusTooltip>
      )}
    </div>
  );
};
